(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backup-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if(this.header.offsetHeight == 0) {
document.documentElement.style.setProperty('--header-height', `${this.header.querySelector('sticky-header').offsetHeight}px`);
      } else {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
      // document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qikify-blog-case-study"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("blog-articles-v2-container");
  if (!container) return;

  const filterGroup = document.querySelector(".blog-filter-group-v2");
  const searchInput = document.getElementById("blog-search-input-v2");
  const industryChips = document.getElementById("blog-industry-chips-v2");
  const appChips = document.getElementById("blog-app-chips-v2");
  const resultCount = document.getElementById("blog-result-count-v2");
  const filterHint = document.getElementById("blog-filter-hint-v2");
  const activeFilters = document.getElementById("blog-active-filters-v2");
  const resetBtn = document.getElementById("blog-reset-btn-v2");
  const noResults = document.getElementById("blog-no-results-v2");
  const paginationContainer = document.getElementById("blog-pagination-v2");

  const cards = Array.from(container.querySelectorAll(".blog-case-study-card-v2"));
  const wrapper = container.closest(".qikify-blog-case-study");
  const postsPerPage = wrapper ? parseInt(wrapper.getAttribute("data-posts-per-page") || "9") : 9;

  const INDUSTRY_ACCENT = "#8B5CF6";
  const SEARCH_ACCENT = "#6B7FD7";
  // App accent + logo are matched by keyword so new app tags still get a sensible look.
  const APP_STYLES = [
    { match: /checkout/, accent: "#D8AD4A", logo: "checkout" },
    { match: /upsell|cross/, accent: "#FC81C7", logo: "upsell" },
    { match: /popup|social/, accent: "#55C76E", logo: "popup" },
    { match: /cart/, accent: "#B2EA44", logo: "cart" },
    { match: /volume|discount|bundle/, accent: "#34E3D8", logo: "volume" }
  ];

  function appStyle(value) {
    const v = (value || "").toLowerCase();
    const found = APP_STYLES.find(s => s.match.test(v));
    if (!found) return { accent: "#9B8AFB", logo: "" };
    const logo = filterGroup ? filterGroup.getAttribute("data-app-logo-" + found.logo) || "" : "";
    return { accent: found.accent, logo: logo };
  }

  function hexA(hex, a) {
    const n = parseInt(hex.replace("#", ""), 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
  }

  function applyAccent(el, accent) {
    el.style.setProperty("--chip-accent", accent);
    el.style.setProperty("--chip-accent-soft", hexA(accent, 0.14));
    el.style.setProperty("--chip-accent-strong", hexA(accent, 0.22));
  }

  // Unique filter values, read from the tag pills rendered on each card (value = lowercase key, label = original text).
  function collectValues(type) {
    const map = new Map();
    container.querySelectorAll(`.tag-pill-item[data-type="${type}"]`).forEach(pill => {
      const label = (pill.getAttribute("data-value") || "").trim();
      const key = label.toLowerCase();
      if (key && !map.has(key)) map.set(key, label);
    });
    return Array.from(map, ([value, label]) => ({ value, label }));
  }

  const industries = collectValues("industry");
  const apps = collectValues("app");

  const state = { industry: "", app: "" };
  let currentPage = 1;
  let filteredCards = [...cards];

  // Card pills pick up the app accent too.
  container.querySelectorAll('.tag-pill-item[data-type="app"]').forEach(pill => {
    applyAccent(pill, appStyle(pill.getAttribute("data-value")).accent);
  });

  function buildChip(type, value, label) {
    const chip = document.createElement("button");
    chip.type = "button";
    chip.className = `filter-chip-v2 filter-chip-${type}-v2`;
    chip.setAttribute("data-value", value);
    if (type === "app" && value) {
      const style = appStyle(label);
      applyAccent(chip, style.accent);
      if (style.logo) {
        const img = document.createElement("img");
        img.src = style.logo;
        img.alt = "";
        img.width = 28;
        img.height = 28;
        img.className = "filter-chip-logo-v2";
        chip.appendChild(img);
        chip.classList.add("has-logo");
      }
    } else {
      applyAccent(chip, INDUSTRY_ACCENT);
    }
    chip.appendChild(document.createTextNode(label));
    chip.addEventListener("click", () => {
      state[type] = value;
      filterCards();
    });
    return chip;
  }

  function renderChips(target, type, values, allLabel) {
    target.innerHTML = "";
    target.appendChild(buildChip(type, "", allLabel));
    values.forEach(v => target.appendChild(buildChip(type, v.value, v.label)));
  }

  renderChips(industryChips, "industry", industries, "All");
  renderChips(appChips, "app", apps, "All apps");

  function syncChipStates() {
    [[industryChips, "industry"], [appChips, "app"]].forEach(([target, type]) => {
      target.querySelectorAll(".filter-chip-v2").forEach(chip => {
        const active = chip.getAttribute("data-value") === state[type];
        chip.classList.toggle("active", active);
        chip.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
  }

  function labelFor(list, value) {
    const found = list.find(v => v.value === value);
    return found ? found.label : value;
  }

  function renderStatus() {
    const count = filteredCards.length;
    resultCount.textContent = `${count} ${count === 1 ? "story" : "stories"}`;

    const items = [];
    if (state.industry) items.push({ label: labelFor(industries, state.industry), accent: INDUSTRY_ACCENT, clear: () => { state.industry = ""; } });
    if (state.app) items.push({ label: labelFor(apps, state.app), accent: appStyle(state.app).accent, clear: () => { state.app = ""; } });
    const query = searchInput.value.trim();
    if (query) items.push({ label: query, accent: SEARCH_ACCENT, clear: () => { searchInput.value = ""; } });

    activeFilters.innerHTML = "";
    items.forEach(item => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "filter-active-chip-v2";
      applyAccent(chip, item.accent);
      chip.setAttribute("aria-label", `Remove filter ${item.label}`);
      chip.appendChild(document.createTextNode(item.label));
      chip.insertAdjacentHTML("beforeend", '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>');
      chip.addEventListener("click", () => {
        item.clear();
        filterCards();
      });
      activeFilters.appendChild(chip);
    });

    const hasFilters = items.length > 0;
    filterHint.hidden = hasFilters;
    activeFilters.hidden = !hasFilters;
    resetBtn.hidden = !hasFilters;
    noResults.hidden = count > 0;
  }

  function updateTagPillActiveStates() {
    container.querySelectorAll(".tag-pill-item").forEach(pill => {
      const type = pill.getAttribute("data-type");
      const val = (pill.getAttribute("data-value") || "").toLowerCase();
      const active = (type === "industry" && state.industry !== "" && val === state.industry)
        || (type === "app" && state.app !== "" && val === state.app);
      pill.classList.toggle("active", active);
      pill.classList.toggle("inactive", !active);
    });
  }

  function filterCards() {
    const searchQuery = searchInput.value.toLowerCase().trim();

    filteredCards = cards.filter(card => {
      const title = card.getAttribute("data-title") || "";
      const name = card.getAttribute("data-name") || "";
      const industry = card.getAttribute("data-industry") || "";
      const app = card.getAttribute("data-app") || "";
      const feature = card.getAttribute("data-feature") || "";

      const matchesSearch = searchQuery === "" || title.includes(searchQuery) || name.includes(searchQuery);
      const matchesIndustry = state.industry === "" || industry === state.industry;
      const matchesApp = state.app === "" || app === state.app || feature === state.app;

      return matchesSearch && matchesIndustry && matchesApp;
    });

    syncChipStates();
    updateTagPillActiveStates();

    currentPage = 1;
    renderGrid();
  }

  function renderGrid() {
    const totalItems = filteredCards.length;
    const totalPages = Math.ceil(totalItems / postsPerPage);

    // Hide all cards
    cards.forEach(card => {
      card.style.display = "none";
    });

    // Show cards for current page
    const start = (currentPage - 1) * postsPerPage;
    const end = start + postsPerPage;
    const visibleCards = filteredCards.slice(start, end);
    visibleCards.forEach(card => {
      card.style.display = "block";
    });

    renderStatus();
    renderPagination(totalPages);
  }

  function renderPagination(totalPages) {
    paginationContainer.innerHTML = "";
    if (totalPages <= 1) return;

    // Previous Arrow
    const prevBtn = document.createElement("button");
    prevBtn.className = "pagination-arrow prev-page";
    prevBtn.disabled = currentPage === 1;
    prevBtn.innerHTML = `<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1.5L2 6.5L7 11.5" stroke="#8C8598" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    prevBtn.addEventListener("click", () => {
      if (currentPage > 1) {
        currentPage--;
        renderGrid();
        scrollToContainer();
      }
    });
    paginationContainer.appendChild(prevBtn);

    // Page Numbers
    for (let i = 1; i <= totalPages; i++) {
      const pageBtn = document.createElement("button");
      pageBtn.className = `pagination-number${i === currentPage ? " active" : ""}`;
      pageBtn.innerText = i;
      pageBtn.addEventListener("click", () => {
        currentPage = i;
        renderGrid();
        scrollToContainer();
      });
      paginationContainer.appendChild(pageBtn);
    }

    // Next Arrow
    const nextBtn = document.createElement("button");
    nextBtn.className = "pagination-arrow next-page";
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.innerHTML = `<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L6 6.5L1 11.5" stroke="#CDC7D6" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    nextBtn.addEventListener("click", () => {
      if (currentPage < totalPages) {
        currentPage++;
        renderGrid();
        scrollToContainer();
      }
    });
    paginationContainer.appendChild(nextBtn);
  }

  function scrollToContainer() {
    container.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  // Event Listeners
  searchInput.addEventListener("input", filterCards);

  // Click handler on tags for quick filtering
  container.addEventListener("click", function(event) {
    const pill = event.target.closest(".tag-pill-item");
    if (!pill) return;

    event.preventDefault();
    event.stopPropagation();

    const type = pill.getAttribute("data-type");
    const value = (pill.getAttribute("data-value") || "").toLowerCase();
    if (type !== "industry" && type !== "app") return;

    state[type] = state[type] === value ? "" : value;
    filterCards();
  });

  resetBtn.addEventListener("click", () => {
    searchInput.value = "";
    state.industry = "";
    state.app = "";
    filterCards();
  });

  // Initial render
  syncChipStates();
  updateTagPillActiveStates();
  renderGrid();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qikify-duos-calculator-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqSections = document.querySelectorAll('.qikify-faq-section');

    faqSections.forEach(section => {
      const headers = section.querySelectorAll('.qikify-accordion-header');

      headers.forEach(header => {
        header.addEventListener('click', () => {
          const item = header.closest('.qikify-accordion-item');
          const isOpen = item.classList.contains('open');

          // Close others? Optional, but often preferred
          section.querySelectorAll('.qikify-accordion-item').forEach(i => i.classList.remove('open'));

          if (!isOpen) {
            item.classList.add('open');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
